export interface ISearch {
  search(query: string): boolean;
}
